import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "ascDesc",
  standalone: true,
})
export class OrderAscDescPipe implements PipeTransform {
  transform(array: any[], field: string, tipo: string = "asc"): any[] {
    if (!Array.isArray(array) || !field) {
      return array;
    }
    const newArray = [...array];
    return newArray.sort((a, b) => {
      const valueA = a[field];
      const valueB = b[field];
      if (tipo === "asc") {
        if (valueA < valueB) {
          return -1;
        } else if (valueA > valueB) {
          return 1;
        } else {
          return 0;
        }
      }
      else if (tipo === "desc") {
        if (valueA < valueB) {
          return 1;
        } else if (valueA > valueB) {
          return -1;
        } else {
          return 0;
        }
      }
      return 0;
    });
  }
}
